// 专门出来用户相关的网络请求
import request from "@/utils/request";

/**
 * @description: 用户登录（统一权限系统）
 */
export function login(data) {
  return request({
    method: "post",
    url: "/auth/login",
    data,
  });
}

// 修改密码 - 超级管理员专用
export function npsw(data) {
  return request({
    method: "post",
    url: "/user/changePassword",
    data,
  });
}

// 修改密码 - 项目用户专用
export function updateProjectPwd(data) {
  return request({
    method: "post",
    url: "/project/updatepwd",
    data,
  });
}

/**
 * @description: 获取用户列表
 */
export function getUserList(data) {
  return request({
    method: "get",
    url: "/project/userlist", // 项目用户列表接口
    params: data,
    data: {},
  });
}

/**
 * @description: 获取全部角色（报警推送接收人选择用）
 */
export function getAllRoles(data) {
  return request({
    method: "get",
    url: "/role/all",
    params: data,
  });
}

/**
 * @description: 系统用户列表（含 email，报警推送接收人选择用）
 */
export function getAllSysUsers(data) {
  return request({
    method: "get",
    url: "/user/list",
    params: data,
  });
}
/**
 * @description: 添加用户
 */
export function add(data) {
  return request({
    method: "post",
    url: "/project/adduser",
    data,
  });
}
/**
 * @description: 修改用户
 */
export function change(data) {
  return request({
    method: "post",
    url: "/project/updateuser",
    data,
  });
}

/**
 * @description: 删除用户
 */
export function del(data) {
  return request({
    method: "get",
    url: "/project/deleteuser",
    params: data,
    data,
  });
}

/**
 * @description: 查询用户
 */
export function serch(data) {
  return request({
    method: "get",
    url: "/userinfo/username",
    params: data,
    data,
  });
}
// 修改头像
export function changeAvatar(data) {
  return request({
    method: "post",
    url: "/user/avatar",
    data,
  });
}
// 获取角色列表
export function getRoleList(data) {
  return request({
    method: "get",
    url: "/rolelist",
    params: data,
    data: {},
  });
}
// 修改用户菜单
export function changeMenu(data) {
  return request({
    method: "post",
    url: "/project/updatemenu",
    data,
  });
}
// 获取用户菜单
export function getMenuList(data) {
  return request({
    method: "get",
    url: "/project/menu",
    params: data,
    data: {},
  });
}
// 添加用户菜单
export function addMenu(data) {
  return request({
    method: "post",
    url: "/project/addmenu",
    data,
  });
}
// 删除用户菜单
export function delMenu(data) {
  return request({
    method: "get",
    url: "/project/deletemenu",
    params: data,
    data: {},
  });
}
export function getRoleMenu(data) {
  return request({
    method: "get",
    url: "/project/rolemenu",
    params: data,
    data: {},
  });
}

export function changeRole(data) {
  return request({
    method: "post",
    url: "/project/changerole",
    data,
  });
}

// ========== 项目授权相关 ==========

// 获取用户授权的项目列表
export function getUserProjects(userId) {
  return request({
    method: "get",
    url: `/user/${userId}/projects`,
  });
}

// 为用户添加项目授权
export function addUserProject(userId, data) {
  return request({
    method: "post",
    url: `/user/${userId}/projects`,
    data,
  });
}

// 删除用户的项目授权
export function removeUserProject(userId, data) {
  return request({
    method: "delete",
    url: `/user/${userId}/projects`,
    data,
  });
}

// ========== 用户注册相关 ==========

// 自助注册
export function registerUser(data) {
  return request({ method: "post", url: "/user/register", data });
}

// 检查用户名是否存在
export function checkUsername(username) {
  return request({ method: "get", url: "/user/check-username", params: { username } });
}

// 审批用户
export function approveUser(data) {
  return request({ method: "post", url: "/user/approve", data });
}

// 发送邮箱验证码
export function sendEmailCode(data) {
  return request({ method: "post", url: "/email/send-code", data });
}

// 校验邮箱验证码
export function verifyEmailCode(data) {
  return request({ method: "post", url: "/email/verify-code", data });
}
